import { useState, type MouseEvent } from 'react';
import { PasswordlessLoginPage } from '../auth/PasswordlessPages';
import { CreatorHero } from './CreatorHero';
import { appUrl } from '../../config/appUrl';
import { ArrowRight, Heart } from 'lucide-react';
import { useAuth } from '../../auth/AuthContext';
import { PublicFooter, PublicHeader, usePublicLocale } from '../../layouts/PublicFrame';
import './about.css';

export function AboutPage() {
  const { locale, changeLocale } = usePublicLocale();
  const { session, restoring } = useAuth();
  const [showRegistration, setShowRegistration] = useState(false);
  const reviewerUrl = session ? appUrl() : '#creator-register-form';
  const startRegistration = (event: MouseEvent<HTMLAnchorElement>) => {
    if (restoring) { event.preventDefault(); return; }
    if (session) return;
    event.preventDefault();
    setShowRegistration(true);
  };
  return <div className="reviewer-about">
    <PublicHeader locale={locale} onLocaleChange={changeLocale} />
    <main>
      <CreatorHero href={reviewerUrl} disabled={restoring} onStart={startRegistration}>
        {showRegistration && !session && !restoring && <div id="creator-register-form"><PasswordlessLoginPage embedded /></div>}
      </CreatorHero>

      <section className="reviewer-about__community">
        <div><p className="reviewer-about__eyebrow">REAL PEOPLE. REAL EXPERIENCE.</p><h2>ทุกประสบการณ์จริง<br />มีเรื่องดี ๆ ให้บอกต่อ</h2><p>ไม่ว่าจะเป็นกาแฟแก้วโปรด ร้านใหม่ที่เพิ่งลอง หรือทริปที่ประทับใจ เรื่องเล่าของคุณช่วยให้คนใน Community ค้นพบสิ่งที่ใช่ และช่วยให้ร้านได้ฟังเสียงจากลูกค้าจริง</p><a href={reviewerUrl} className="reviewer-about__cta" aria-disabled={restoring || undefined} onClick={startRegistration}>มาเป็น Reviewer ด้วยกัน <ArrowRight size={20} /></a></div>
        <div className="reviewer-about__reward"><Heart size={32} aria-hidden="true" /><span>รีวิวจริง ได้จริง</span><strong>฿10</strong><p>รับ Reward จากร้านที่ร่วมรายการ</p><small>ตามเงื่อนไขของแต่ละรายการ</small></div>
      </section>
      <section className="reviewer-about__operator" aria-label="ผู้ให้บริการ">
        <p>ให้บริการโดย</p>
        <strong>บริษัท ลิเบอร์ตี้ แอนด์ สกาย จำกัด (Liberty and Skye Co., LTD)</strong>
      </section>
    </main>
    <PublicFooter />
  </div>;
}
